import axios from 'axios'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col,Card, Modal, Container, OverlayTrigger, Tooltip, Form } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min'


const Grilla = ({handleClose}) => {
  const [show, setShow] = useState(false) 
const [listaGrilla,setListaGrilla]= useState('') 
  const data_gastos = useSelector((state) => state.provisionGastosReducer)
   const { cfg_form34, datosGrilla} = data_gastos

 useEffect(()=>{
  setListaGrilla(datosGrilla && datosGrilla.datosGrilla)
 },[datosGrilla])
 useEffect(()=>{
  setListaGrilla('')
 },[])
 const obtenerColumnas = () => {
 
    return [
      
      
      {
        dataField: 'glosaTipoGasto',
        text:cfg_form34 ? cfg_form34.cfg_form34[
          'modalconsultagastos-grilla-tipogasto'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            { column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'glosaCobertura',
        text: cfg_form34 ? cfg_form34.cfg_form34[
          'modalconsultagastos-grilla-cobertura'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            { column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'fechaOcurrenciaFormat',
        text: cfg_form34 ? cfg_form34.cfg_form34[
          'lconsultagastos-grilla-fechaocurre'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' }
      },
      {
        dataField: 'glosaMoneda',
        text:cfg_form34 ? cfg_form34.cfg_form34[
          'modalconsultagastos-grilla-moneda'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
             {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: { backgroundColor: '#728bb0', color: 'white' },
        
      },
      {
        dataField: 'montoProvision',
        text: cfg_form34 ?cfg_form34.cfg_form34[
          'modalconsultagastos-grilla-monto'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
            { column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      
      {
        dataField: 'comentario',
        text: cfg_form34 ? cfg_form34.cfg_form34[
          'modalconsultagastos-grilla-comentario'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
             {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        },
        formatter:(cell, row)=>{
          if(cell?.length>30) {
            return <>        
                <a href='#' style={{textDecoration:'none'}} onClick={(e)=>{
                   e.preventDefault()
                  alert(cell)}}>{cell?.substring(0,30)}</a>
                  
            </>
           }else{
               return cell
           }
         }
      },
      {
        dataField: 'usuario',
        text: cfg_form34 ? cfg_form34.cfg_form34[
          'modalconsultagastos-grilla-usuario'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
             {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
        dataField: 'fechaIngresoFormat',
        text: cfg_form34 ? cfg_form34.cfg_form34[
          'modalconsultagastos-grilla-fecharegistro'
        ]:'',
        sort: true,
        headerAlign: 'center',
        align: 'center',
        headerFormatter: (column, colIndex, { sortElement, filterElement }) => (
          <div>
             {column.text}
            <br />
            {sortElement}
          </div>
        ),
        headerStyle: {
          backgroundColor: '#728bb0',
          color: 'white',
          verticalAlign: 'middle'
        }
      },
      {
          dataField: 'opciones',
          text: '',
          isDummyField: true,
          headerStyle: (colum, colIndex) => {
            return {
              width: '40%',
              textAlign: 'center',
              verticalAlign: 'center',
              backgroundColor: '#728bb0',
              color: 'white'
            }
          },
          style: { textAlign: 'center', verticalAlign: 'middle' },
          formatter: (cell, row) => (
            
           <div>
              {
              parseInt(row.idfolioCargaDocto) > 0  ? ( <OverlayTrigger
                overlay={<Tooltip id='tooltip-disabled'>Detalles </Tooltip>}
              >
                <Button
                  type='button'
                  variant='outline-secondary me-md-2'
                  size='sm'
                 
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
                            </svg>
                </Button>
              </OverlayTrigger>):null
              
              }
            </div>
          ),
          headerStyle: { backgroundColor: '#728bb0', color: 'white' }
        }
      
     
    ]
  
}

  return (
    <>
     
      <Card >
      <Container>
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white', textAlign:'center' }}
          >
            {cfg_form34
              ? cfg_form34.cfg_form34['modalconsultagastos-title']
              : ''} 
          </Card.Header>
      <Row className='mt-1 mb-3'>
          <Col>
            <ToolkitProvider
                search
                bootstrap4
                keyField='secProvision'
                data={listaGrilla ? listaGrilla : []}
                columns={cfg_form34 ? obtenerColumnas():[]}
                defaultSorted={[{ dataField: 'sesecProvision', order: 'asc' }]}
               
                >
                {(props) => (
                    <div>
                   

                    <BootstrapTable
                        {...props.baseProps}
                        bordered={false}
                        headerWrapperClasses='table-secondary'
                        pagination={paginationFactory({ sizePerPage: 5})}
                        noDataIndication={
                        <div className='text-center'>
                            No hay registros encontrados
                        </div>
                        }
                    />
                    </div>
                )}
            </ToolkitProvider>
          </Col>
      </Row>
      <Row>
                <Col className='d-flex align-items-end justify-content-end m-2'>
                <Button className='m-2 w-auto' variant='outline-info' onClick={handleClose}   >
                {cfg_form34 && cfg_form34.cfg_form34["modalconsultagastos-btn-cerrar"]}
                
          </Button>
          </Col>
           </Row>
      </Container>
      </Card>
    </>
  )
}

export default Grilla
